import {ClsCalendario} from "./cls-catalogos";
import {ClsProgramaDeObraGrid} from "./cls-presupuestos";
import {IContextoProgramacionObra, IFechasPeriodo} from "./cls-sobrecosto";

export class ClsPrograma {
  IdPrograma: bigint;
  NoPrograma: number;
  Descripcion: string;
  IdCalendario: bigint;
  Calendario?: ClsCalendario;
  FechaInicio: Date;
  FechaFinal: Date;
  NoPeriodos: number;
  Periodicidad: number;
  CapturarPorcentaje: boolean;
  Vigente: boolean;
  DiasCalendario: number;
  DiasHabiles: number;
  RecorrerFechasInicio?: boolean;
  BorrarRelacionesActuales?: boolean;
  JsonDetallePrograma: string;
  JsonRelaciones: string;
  JsonProgSum: string;
  // esto se ocupa para sobrecosto y calculo del presupuesto
  LsPorcFinanciamiento?: ClsPorcentajesFinanciamiento[];
}

export class DetalleJsonDetallePrograma {
  Control: number;
  IdResponsable: bigint;
  FechaInicio: Date;
  FechaFinal: Date;
  Duracion: number;
  Rendimiento: number;
  ActividadCritica: boolean;
  Holgura: number;
  FechaInicioTardia: Date;
  FechaFinalTardia: Date;
  Avance: number;
  FechaInicioReal: Date;
  FechaFinalReal: Date;
  Periodos?: DetalleJsonRelaciones[];
}

export class DetalleJsonRelaciones {
  NumeroPeriodo: number;
  porcentajeCantidad: number;
}

export class ClsPorcentajesFinanciamiento {
  IdPresupuesto: bigint;
  IdPrograma: bigint
  IdPorcentajeFinanciamiento: bigint
  NoPeriodo: number
  JsonPorcentajesFM: string
}

/**
 * Parámetros para registrar en el grid (batch) los totales y columnas de un periodo
 * tras editar cantidad o porcentaje en programación por periodos.
 */
export class ClsParamActualizarCeldasProgramaObra {
  rowId: any;
  cantidadCapturadoFinal: number;
  porcentajeCapturadoFinal: number;
  nuevoCantPorcTotal: number;
  nuevoCostoPeriodo: number;
  nuevoMontoTotal: number;
  campoCantidad: string;
  campoMoneda: string;
  esPorcentaje: boolean;
  valorCapturaCelda: any;
}

export class ClsInicializarDataOpts {
  detallePorDefecto?: boolean;
  fechaInicioPrograma?: Date;
}

/** Una celda de periodo a aplicar en pegado (ya parseada). */
export interface ICeldaPegadoPeriodo {
  field: string;
  valor: number;
}

/** Contexto de anclaje del pegado en el grid. */
export interface IContextoPegadoPeriodos {
  rowIndex: number;
  cellIndex: number;
  textoPeriodo: string;
  esPorcentaje: boolean;
}

/** Opciones internas para actualizarCeldas / transacciones. */
export interface IOpcionesActualizarCeldas {
  deferMarkForCheck?: boolean;
  rowData?: ClsProgramaDeObraGrid;
}

/** Contexto del programa para sincronizar fechas ↔ periodos en programación por %/montos. */
export interface ISyncProgramacionObra {
  ctx: IContextoProgramacionObra;
  mapaPeriodos: Map<number, IFechasPeriodo>;
  periodosAlternos: any[];
}

/** Detalle de un concepto dentro de JsonDetallePrograma (parseo por línea). */
export interface IDetalleConceptoJsonPrograma {
  fechaInicio: string;
  fechaFinal: string;
  duracion?: number;
  rendimiento?: number;
  porcentajes: { numeroPeriodo: number; valor: number }[];
}

export interface IFechasInsumoPrograma {
  inicio: Date;
  fin: Date;
}
